import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const DateFormet = ({data}) => {
  const formattedDate = format(new Date(data), "hh:mm a, dd MMM yyyy")
  return <div>{formattedDate}</div>;
};

export default DateFormet;
